import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  touch-action: none;
`;

const MobileFrame = styled.div`
  width: 100%;
  max-width: 390px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #000000;
`;

const HomeButtonContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1000;
`;

const HomeButton = styled.span`
  color: white;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 3px;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 1;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`;

const ImageWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  overflow: hidden;
`;

const ImageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.div`
  font-size: 120px;
  margin-bottom: 40px;
  filter: drop-shadow(0 0 20px rgba(255, 149, 0, 0.5));
`;

const ImageGradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60%;
  background: linear-gradient(to top, #000000 0%, rgba(0, 0, 0, 0.8) 50%, transparent 100%);
  pointer-events: none;
`;

const Branding = styled.div`
  position: absolute;
  bottom: 180px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
  
  p {
    color: white;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 3px;
    text-transform: uppercase;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 20px 40px;
  position: relative;
  z-index: 10;
`;

const Button = styled.button`
  background-color: #FF9500;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 16px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  
  &:hover {
    background-color: #FF8800;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    
    &:hover {
      background-color: #FF9500;
      transform: none;
    }
  }
`;

const TourManagerApp = () => {
  const navigate = useNavigate();

  // Add useEffect for scroll prevention
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    document.body.style.touchAction = 'none';

    return () => {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = 'unset';
      document.body.style.position = 'static';
      document.body.style.width = 'auto';
      document.body.style.height = 'auto';
      document.body.style.touchAction = 'auto';
    };
  }, []);

  const handleViewAll = () => {
    navigate('/tour-manager/view-all');
  };

  const handleImport = () => {
    navigate('/tour-manager/bulk-import');
  };

  const handleTourRouter = () => {
    navigate('/tour-manager/tour-router');
  };

  return (
    <Container>
      <MobileFrame>
        <HomeButtonContainer>
          <HomeButton onClick={() => navigate('/')}>HOME</HomeButton>
        </HomeButtonContainer>
        <Content>
          <ImageWrapper>
            <ImageContainer>
              <Icon>TOUR</Icon>
            </ImageContainer>
            <ImageGradient />
            <Branding>
              <p>T O U R M N G R</p>
            </Branding>
          </ImageWrapper>
          <ButtonsContainer>
            <Button className="disabled" title="Coming soon">
              Login with agency
            </Button>
            <Button onClick={handleTourRouter}>
              Smart Tour Router
            </Button>
            <Button onClick={handleImport}>
              Import from bookings
            </Button>
            <Button onClick={handleViewAll}>
              View all shows
            </Button>
          </ButtonsContainer>
        </Content>
      </MobileFrame>
    </Container>
  );
};

export default TourManagerApp;

